'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateSelector = exports.resetTemplateConfiguration = exports.cancelTemplateConfiguration = exports.changeComponentProperty = exports.changeTemplatesRowProperty = exports.changeTemplatesProperty = exports.changeProperty = exports.selectComponent = exports.deleteTemplateConfiguration = exports.saveTemplate = exports.getTemplate = exports.getTemplates = exports.cloneTemplate = exports.deleteTemplate = exports.loadTemplate = exports.setCurrentTemplate = exports.setTab = exports.initialState = exports.RESET_TEMPLATE_CONFIGURATION = exports.CANCEL_TEMPLATE_CONFIGURATION = exports.CHANGE_TEMPLATES_ROW = exports.CHANGE_TEMPLATES_PROPERTY = exports.CHANGE_COMPONENT_PROPERTY = exports.CHANGE_PROPERTY = exports.SELECT_COMPONENT = exports.DELETE_TEMPLATE_CONFIG = exports.DELETE_TEMPLATE = exports.CLONE_TEMPLATE = exports.SAVE_TEMPLATE_TYPES = exports.GET_TEMPLATE_TYPES = exports.GET_TEMPLATES_TYPES = exports.LOAD_TEMPLATE = exports.SET_CURRENT_TEMPLATE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends10 = require('babel-runtime/helpers/extends');

var _extends11 = _interopRequireDefault(_extends10);

exports.default = reducer;
exports.fetchTemplatesSaga = fetchTemplatesSaga;
exports.fetchTemplateSaga = fetchTemplateSaga;
exports.saveTemplateSaga = saveTemplateSaga;
exports.setCurrentTemplateSaga = setCurrentTemplateSaga;
exports.watchGetTemplates = watchGetTemplates;
exports.watchGetTemplate = watchGetTemplate;
exports.watchSaveTemplate = watchSaveTemplate;
exports.watchSetCurrentTemplate = watchSetCurrentTemplate;
exports.watchCloneTemplate = watchCloneTemplate;
exports.watchCancelTemplateConfiguration = watchCancelTemplateConfiguration;
exports.watchDeleteTemplateConfigurationSaga = watchDeleteTemplateConfigurationSaga;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

var _reactRouter = require('react-router');

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _createFetchTypes = require('../../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _notifications = require('../notifications');

var _createTemplate = require('./createTemplate');

var _createTemplate2 = _interopRequireDefault(_createTemplate);

var _index = require('./index');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchTemplatesSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchTemplateSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(saveTemplateSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(setCurrentTemplateSaga),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(afterCloneTemplateSaga),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(afterCancelTemplateConfiguration),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(deleteTemplateConfigurationSaga),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchGetTemplates),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(watchGetTemplate),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(watchSaveTemplate),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(watchSetCurrentTemplate),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(watchCloneTemplate),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(watchCancelTemplateConfiguration),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(watchDeleteTemplateConfigurationSaga);

var SET_CURRENT_TEMPLATE = exports.SET_CURRENT_TEMPLATE = 'tq-plus-admin/templates/SET_CURRENT_TEMPLATE';
var LOAD_TEMPLATE = exports.LOAD_TEMPLATE = 'tq-plus-admin/templates/LOAD_TEMPLATE';
var GET_TEMPLATES_TYPES = exports.GET_TEMPLATES_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/templates/GET_TEMPLATES');
var GET_TEMPLATE_TYPES = exports.GET_TEMPLATE_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/templates/GET_TEMPLATE');
var SAVE_TEMPLATE_TYPES = exports.SAVE_TEMPLATE_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/templates/SAVE_TEMPLATE');
var CLONE_TEMPLATE = exports.CLONE_TEMPLATE = 'tq-plus-admin/templates/CLONE_TEMPLATE';
var DELETE_TEMPLATE = exports.DELETE_TEMPLATE = 'tq-plus-admin/templates/DELETE_TEMPLATE';
var DELETE_TEMPLATE_CONFIG = exports.DELETE_TEMPLATE_CONFIG = (0, _createFetchTypes2.default)('tq-plus-admin/templates/DELETE_TEMPLATE_CONFIG');

// TEMPLATE EDITOR ACTIONS
var SELECT_COMPONENT = exports.SELECT_COMPONENT = 'tq-plus-admin/templates/SELECT_COMPONENT';
var CHANGE_PROPERTY = exports.CHANGE_PROPERTY = 'tq-plus-admin/templates/CHANGE_PROPERTY';
var CHANGE_COMPONENT_PROPERTY = exports.CHANGE_COMPONENT_PROPERTY = 'tq-plus-admin/templates/CHANGE_COMPONENT_PROPERTY';
var CHANGE_TEMPLATES_PROPERTY = exports.CHANGE_TEMPLATES_PROPERTY = 'tq-plus-admin/templates/CHANGE_TEMPLATES_PROPERTY';
var CHANGE_TEMPLATES_ROW = exports.CHANGE_TEMPLATES_ROW = 'tq-plus-admin/templates/CHANGE_TEMPLATES_ROW';
var CANCEL_TEMPLATE_CONFIGURATION = exports.CANCEL_TEMPLATE_CONFIGURATION = 'tq-plus-admin/templates/CANCEL_TEMPLATE_CONFIGURATION';
var RESET_TEMPLATE_CONFIGURATION = exports.RESET_TEMPLATE_CONFIGURATION = 'tq-plus-admin/templates/CANCEL_TEMPLATE_RESET';

var initialState = exports.initialState = {
  current: {},
  currentDefault: null,
  templates: {},
  edited: [],
  removed: [],
  defaultTemplateId: null,
  currentTemplate: null,
  currentTemplateUnmodified: null,
  error: null,
  tab: 0,

  templatesStatus: STATUS.UNRETRIEVED,
  templateStatus: STATUS.UNRETRIEVED
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'SWITCH_TAB':
      {
        return (0, _extends11.default)({}, state, { tab: action.tab });
      }

    case SET_CURRENT_TEMPLATE:
    case LOAD_TEMPLATE:
      {
        var template = action.template;

        // If a template is not received, create a new one by default.

        if (template === undefined || template === null) {
          template = (0, _extends11.default)({}, (0, _createTemplate2.default)(), { isNew: true });
        }

        // When it comes from the server [fetching]
        if ((typeof template === 'undefined' ? 'undefined' : (0, _typeof3.default)(template)) === 'object') {
          var _template2 = template,
              components = _template2.components;
          // If components is stringified, parse it to JS object

          if (typeof components === 'string') components = JSON.parse(components);
          var _template = (0, _extends11.default)({}, template, { components: components });
          return (0, _extends11.default)({}, state, { currentTemplate: _template, currentTemplateUnmodified: _template });
        }

        var currentTemplate = state.templates[template] || null;
        return (0, _extends11.default)({}, state, { currentTemplate: currentTemplate, currentTemplateUnmodified: currentTemplate });
      }

    case GET_TEMPLATES_TYPES.REQUEST:
      return (0, _extends11.default)({}, state, { templatesStatus: STATUS.REQUESTING });
    case GET_TEMPLATE_TYPES.REQUEST:
      return (0, _extends11.default)({}, state, { templateStatus: STATUS.REQUESTING });

    case GET_TEMPLATES_TYPES.FAILURE:
      return (0, _extends11.default)({}, state, { templatesStatus: STATUS.FAILED, error: action.error });
    case GET_TEMPLATE_TYPES.FAILURE:
      return (0, _extends11.default)({}, state, { templateStatus: STATUS.FAILED, error: action.error });

    case GET_TEMPLATES_TYPES.SUCCESS:
      {
        var templates = action.templates;


        var temp = templates.result.reduce(function (temps, template) {
          var _templates = temps;
          var components = template.components;

          if (typeof components === 'string') {
            components = JSON.parse(components);
          }
          _templates[template.id] = (0, _extends11.default)({}, template, {
            components: components
          });
          return _templates;
        }, {});

        return (0, _extends11.default)({}, state, {
          templatesStatus: STATUS.SUCCEEDED,
          error: null,
          current: temp,
          templates: temp,
          currentDefault: templates.defaultTemplate,
          defaultTemplateId: templates.defaultTemplate
        });
      }

    case GET_TEMPLATE_TYPES.SUCCESS:
      {
        var _components = action.template.components;

        if (typeof _components === 'string') {
          _components = JSON.parse(_components);
        }
        return (0, _extends11.default)({}, state, {
          templateStatus: STATUS.SUCCEEDED,
          error: null,
          templates: (0, _extends11.default)({}, state.templates, (0, _defineProperty3.default)({}, action.template.id, (0, _extends11.default)({}, action.template, {
            components: _components
          })))
        });
      }

    // TEMPLATE EDITOR
    case SELECT_COMPONENT:
      return (0, _extends11.default)({}, state, {
        currentTemplate: (0, _extends11.default)({}, state.currentTemplate, {
          selectedComponent: action.component
        })
      });

    case CHANGE_TEMPLATES_ROW:
      {
        var _templates2 = state.templates;

        var selectedTemplate = _templates2[action.id];
        if (selectedTemplate !== 'undefined') {
          // since we are currently only editing the isEnabled field, only edited array is needed
          var propertyIndex = state.edited.findIndex(function (item) {
            return item.id === action.id;
          });
          if (propertyIndex === -1) propertyIndex = state.edited.length;
          return (0, _extends11.default)({}, state, {
            templates: (0, _extends11.default)({}, _templates2, (0, _defineProperty3.default)({}, action.id, (0, _extends11.default)({}, selectedTemplate, (0, _defineProperty3.default)({}, action.property, action.newValue)))),
            edited: [].concat((0, _toConsumableArray3.default)(state.edited.slice(0, propertyIndex)), [selectedTemplate])
          }, state.edited.slice(propertyIndex + 1));
        }
        break;
      }

    case CHANGE_TEMPLATES_PROPERTY:
      return action.property && (0, _extends11.default)({}, state, (0, _defineProperty3.default)({}, action.property, action.newValue)) || state;

    case CHANGE_PROPERTY:
      return action.property && (0, _extends11.default)({}, state, {
        currentTemplate: (0, _extends11.default)({}, state.currentTemplate, (0, _defineProperty3.default)({}, action.property, action.newValue))
      }) || state;

    case CHANGE_COMPONENT_PROPERTY:
      {
        var _ref = state.currentTemplate || {},
            _components2 = _ref.components;

        var component = _components2[action.component];
        var property = action.property || 'value';

        return (0, _extends11.default)({}, state, {
          currentTemplate: (0, _extends11.default)({}, state.currentTemplate, {
            components: (0, _extends11.default)({}, _components2, (0, _defineProperty3.default)({}, action.component, (0, _extends11.default)({}, component, (0, _defineProperty3.default)({}, property, action.newValue))))
          })
        });
      }
    case SAVE_TEMPLATE_TYPES.REQUEST:
      return (0, _extends11.default)({}, state);
    case SAVE_TEMPLATE_TYPES.FAILURE:
      return (0, _extends11.default)({}, state, { error: action.error });
    case SAVE_TEMPLATE_TYPES.SUCCESS:
      {
        return (0, _extends11.default)({}, state, {
          current: (0, _extends11.default)({}, state.templates),
          currentDefault: state.defaultTemplateId,
          currentTemplate: (0, _extends11.default)({}, state.currentTemplate, { id: String(action.template) }),
          templates: (0, _extends11.default)({}, state.templates, (0, _defineProperty3.default)({}, action.template, (0, _extends11.default)({}, state.currentTemplate, { id: String(action.template) })))
        });
      }

    case DELETE_TEMPLATE_CONFIG.REQUEST:
      return (0, _extends11.default)({}, state);
    case DELETE_TEMPLATE_CONFIG.FAILURE:
      return (0, _extends11.default)({}, state, { error: action.error });
    case DELETE_TEMPLATE_CONFIG.SUCCESS:
      {
        var templatesResult = (0, _extends11.default)({}, state.templates);
        delete templatesResult[action.id];
        return (0, _extends11.default)({}, state, {
          removed: [].concat((0, _toConsumableArray3.default)(state.removed), [action.id]),
          templates: templatesResult
        });
      }

    case DELETE_TEMPLATE:
      {
        var _templatesResult = (0, _extends11.default)({}, state.templates);
        delete _templatesResult[action.id];
        //deleted template isDefault=true
        var defaultTemplateIdTemp = state.defaultTemplateId;
        var currentDefaultTemp = state.currentDefault;
        if (state.defaultTemplateId == action.id) {
          var idStandard = (0, _keys2.default)(_templatesResult).map(function (value) {
            if (_templatesResult[value].isDefault === true) {
              return value;
            }
          });
          currentDefaultTemp = idStandard[0];
          defaultTemplateIdTemp = idStandard[0];
        }

        return (0, _extends11.default)({}, state, {
          removed: [].concat((0, _toConsumableArray3.default)(state.removed), [action.id]),
          templates: _templatesResult,
          currentDefault: currentDefaultTemp,
          defaultTemplateId: defaultTemplateIdTemp
        });
      }

    case CLONE_TEMPLATE:
      {
        var _template3 = action.template;

        _template3 = (0, _extends11.default)({}, _template3, { id: 0, isNew: true, isDefault: false });
        return (0, _extends11.default)({}, state, {
          currentTemplate: _template3,
          currentTemplateUnmodified: _template3
        });
      }

    case _index.CANCEL_TEMPLATE_SETTINGS:
      return (0, _extends11.default)({}, state, {
        templates: (0, _extends11.default)({}, state.current),
        defaultTemplateId: state.currentDefault,
        edited: [],
        removed: []
      });

    case CANCEL_TEMPLATE_CONFIGURATION:
      {
        return (0, _extends11.default)({}, state, {
          currentTemplate: {},
          currentTemplateUnmodified: {}
        });
      }

    case RESET_TEMPLATE_CONFIGURATION:
      {
        var currentTemplateUnmodified = state.currentTemplateUnmodified;

        return (0, _extends11.default)({}, state, {
          currentTemplate: currentTemplateUnmodified
        });
      }

    default:
      return state;
  }
  return state;
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var setTab = exports.setTab = function setTab(tab, id) {
  return changeComponentProperty(id, 'activeTab', tab);
};

var setCurrentTemplate = exports.setCurrentTemplate = function setCurrentTemplate(template, isNew) {
  return {
    type: SET_CURRENT_TEMPLATE,
    template: template,
    isNew: isNew
  };
};

var loadTemplate = exports.loadTemplate = function loadTemplate(template, isNew) {
  return {
    type: LOAD_TEMPLATE,
    template: template,
    isNew: isNew
  };
};

var deleteTemplate = exports.deleteTemplate = function deleteTemplate(id) {
  return {
    type: DELETE_TEMPLATE,
    id: id
  };
};

var cloneTemplate = exports.cloneTemplate = function cloneTemplate(template) {
  return {
    type: CLONE_TEMPLATE,
    template: template
  };
};

var getTemplates = exports.getTemplates = {
  base: function base(token) {
    return {
      type: GET_TEMPLATES_TYPES.BASE,
      url: 'template-configuration/get-templates',
      token: token
    };
  },
  request: function request() {
    return { type: GET_TEMPLATES_TYPES.REQUEST };
  },
  success: function success(templates) {
    return { type: GET_TEMPLATES_TYPES.SUCCESS, templates: templates };
  },
  failure: function failure(error) {
    return { type: GET_TEMPLATES_TYPES.FAILURE, error: error };
  }
};

var getTemplate = exports.getTemplate = {
  base: function base(template, token) {
    return {
      type: GET_TEMPLATE_TYPES.BASE,
      url: 'template-configuration/get-template',
      params: { id: template },
      token: token
    };
  },
  request: function request() {
    return { type: GET_TEMPLATE_TYPES.REQUEST };
  },
  success: function success(template) {
    return { type: GET_TEMPLATE_TYPES.SUCCESS, template: template };
  },
  failure: function failure(error) {
    return { type: GET_TEMPLATE_TYPES.FAILURE, error: error };
  }
};

var saveTemplate = exports.saveTemplate = {
  base: function base(currentTemplate, token) {
    return {
      type: SAVE_TEMPLATE_TYPES.BASE,
      url: 'template-configuration/save-template',
      data: { currentTemplate: currentTemplate },
      token: token
    };
  },
  request: function request() {
    return { type: SAVE_TEMPLATE_TYPES.REQUEST };
  },
  success: function success(template) {
    return { type: SAVE_TEMPLATE_TYPES.SUCCESS, template: template };
  },
  failure: function failure(error) {
    return { type: SAVE_TEMPLATE_TYPES.FAILURE, error: error };
  }
};

var deleteTemplateConfiguration = exports.deleteTemplateConfiguration = {
  base: function base(id, token) {
    return {
      type: DELETE_TEMPLATE_CONFIG.BASE,
      url: 'template-configuration/delete-template',
      params: { id: id },
      token: token
    };
  },
  request: function request() {
    return { type: DELETE_TEMPLATE_CONFIG.REQUEST };
  },
  success: function success(id) {
    return { type: DELETE_TEMPLATE_CONFIG.SUCCESS, id: id };
  },
  failure: function failure(error) {
    return { type: DELETE_TEMPLATE_CONFIG.FAILURE, error: error };
  }
};

// TEMPLATE EDITOR ACTIONS
var selectComponent = exports.selectComponent = function selectComponent(component) {
  return { type: SELECT_COMPONENT, component: component };
};
var changeProperty = exports.changeProperty = function changeProperty(property, newValue, previousValue) {
  return {
    type: CHANGE_PROPERTY, property: property, newValue: newValue, previousValue: previousValue
  };
};
var changeTemplatesProperty = exports.changeTemplatesProperty = function changeTemplatesProperty(property, newValue) {
  return {
    type: CHANGE_TEMPLATES_PROPERTY, property: property, newValue: newValue
  };
};
var changeTemplatesRowProperty = exports.changeTemplatesRowProperty = function changeTemplatesRowProperty(property, newValue, id) {
  return {
    type: CHANGE_TEMPLATES_ROW, property: property, newValue: newValue, id: id
  };
};
var changeComponentProperty = exports.changeComponentProperty = function changeComponentProperty(component, property, newValue, previousValue) {
  return {
    type: CHANGE_COMPONENT_PROPERTY, component: component, property: property, newValue: newValue, previousValue: previousValue
  };
};
var cancelTemplateConfiguration = exports.cancelTemplateConfiguration = function cancelTemplateConfiguration() {
  return { type: CANCEL_TEMPLATE_CONFIGURATION };
};

var resetTemplateConfiguration = exports.resetTemplateConfiguration = function resetTemplateConfiguration() {
  return { type: RESET_TEMPLATE_CONFIGURATION };
};
/* SELECTORS
 * ---------------------------------------------------------------------------------------------- */
var templateSelector = exports.templateSelector = function templateSelector(state, id) {
  return state.templateApplication.templates.templates[id];
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
// FETCHERS -----
function fetchTemplatesSaga(_ref2) {
  var url = _ref2.url,
      token = _ref2.token;
  return _regenerator2.default.wrap(function fetchTemplatesSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(getTemplates, _api2.default.get, url, { token: token });
          });

        case 3:
          return _context.abrupt('return', _context.sent);

        case 6:
          _context.prev = 6;
          _context.t0 = _context['catch'](0);
          _context.next = 10;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error retrieving templates',
            message: _context.t0.message
          }));

        case 10:

          console.error(_context.t0);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 6]]);
}

function fetchTemplateSaga(_ref3) {
  var url = _ref3.url,
      params = _ref3.params,
      token = _ref3.token;
  return _regenerator2.default.wrap(function fetchTemplateSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(getTemplate, _api2.default.get, url, { params: params, token: token });
          });

        case 3:
          return _context2.abrupt('return', _context2.sent);

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 10;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error retrieving template ' + (params && params.id),
            message: _context2.t0.message
          }));

        case 10:

          console.error(_context2.t0);

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 6]]);
}

function saveTemplateSaga(_ref4) {
  var url = _ref4.url,
      data = _ref4.data,
      token = _ref4.token;
  var result;
  return _regenerator2.default.wrap(function saveTemplateSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(saveTemplate, _api2.default.post, url, { data: data, token: token });
          });

        case 3:
          result = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)((0, _notifications.success)({
            title: 'Success',
            message: 'Template information has been saved correctly'
          }));

        case 6:
          return _context3.abrupt('return', result);

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 13;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error saving template',
            message: _context3.t0.message
          }));

        case 13:

          console.error(_context3.t0);

        case 14:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 9]]);
}

function setCurrentTemplateSaga(_ref5) {
  var templateId = _ref5.template,
      isNew = _ref5.isNew,
      token = _ref5.token;
  var template;
  return _regenerator2.default.wrap(function setCurrentTemplateSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!isNew) {
            _context4.next = 4;
            break;
          }

          _context4.next = 3;
          return (0, _effects.put)(loadTemplate((0, _extends11.default)({}, (0, _createTemplate2.default)(), { isNew: true })));

        case 3:
          return _context4.abrupt('return', _context4.sent);

        case 4:
          _context4.next = 6;
          return (0, _effects.select)(templateSelector, templateId);

        case 6:
          template = _context4.sent;

          if (template) {
            _context4.next = 11;
            break;
          }

          _context4.next = 10;
          return (0, _effects.call)(fetchTemplateSaga, getTemplate.base(templateId, token));

        case 10:
          template = _context4.sent;

        case 11:
          _context4.next = 13;
          return (0, _effects.put)(loadTemplate(template));

        case 13:
          return _context4.abrupt('return', _context4.sent);

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function afterCloneTemplateSaga() {
  return _regenerator2.default.wrap(function afterCloneTemplateSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/template-application/template-configuration'));

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function afterCancelTemplateConfiguration() {
  return _regenerator2.default.wrap(function afterCancelTemplateConfiguration$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/template-application'));

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function deleteTemplateConfigurationSaga(_ref6) {
  var url = _ref6.url,
      params = _ref6.params,
      token = _ref6.token;
  var result;
  return _regenerator2.default.wrap(function deleteTemplateConfigurationSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(deleteTemplateConfiguration, _api2.default.post, url, { params: params, token: token });
          });

        case 3:
          result = _context7.sent;


          _reactRouter.browserHistory.push('/template-application');
          return _context7.abrupt('return', result);

        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7['catch'](0);
          _context7.next = 12;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error retrieving template ' + (params && params.id),
            message: _context7.t0.message
          }));

        case 12:

          console.error(_context7.t0);

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[0, 8]]);
}

// WATCHERS -----
function watchGetTemplates() {
  return _regenerator2.default.wrap(function watchGetTemplates$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.delegateYield((0, _reduxSaga.takeLatest)(GET_TEMPLATES_TYPES.BASE, fetchTemplatesSaga), 't0', 1);

        case 1:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function watchGetTemplate() {
  return _regenerator2.default.wrap(function watchGetTemplate$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.delegateYield((0, _reduxSaga.takeLatest)(GET_TEMPLATE_TYPES.BASE, fetchTemplateSaga), 't0', 1);

        case 1:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function watchSaveTemplate() {
  return _regenerator2.default.wrap(function watchSaveTemplate$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.delegateYield((0, _reduxSaga.takeLatest)(SAVE_TEMPLATE_TYPES.BASE, saveTemplateSaga), 't0', 1);

        case 1:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function watchSetCurrentTemplate() {
  return _regenerator2.default.wrap(function watchSetCurrentTemplate$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.delegateYield((0, _reduxSaga.takeLatest)(SET_CURRENT_TEMPLATE, setCurrentTemplateSaga), 't0', 1);

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function watchCloneTemplate() {
  return _regenerator2.default.wrap(function watchCloneTemplate$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.delegateYield((0, _reduxSaga.takeLatest)(CLONE_TEMPLATE, afterCloneTemplateSaga), 't0', 1);

        case 1:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function watchCancelTemplateConfiguration() {
  return _regenerator2.default.wrap(function watchCancelTemplateConfiguration$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.delegateYield((0, _reduxSaga.takeLatest)(CANCEL_TEMPLATE_CONFIGURATION, afterCancelTemplateConfiguration), 't0', 1);

        case 1:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function watchDeleteTemplateConfigurationSaga() {
  return _regenerator2.default.wrap(function watchDeleteTemplateConfigurationSaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.delegateYield((0, _reduxSaga.takeLatest)(DELETE_TEMPLATE_CONFIG.BASE, deleteTemplateConfigurationSaga), 't0', 1);

        case 1:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/templates/templates.js
// module id = 1663
// module chunks = 0